import React, { useEffect, useState } from "react";
import { actionByID } from "../../Model/Auction";
import { decodeId } from "../../hash";
import { useParams } from "react-router-dom";
import Lot from "./Lot";
import Banner from "./components/Banner";
import LotSEO from "./components/LotSEO";

const View = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);

  useEffect(() => {
    let isActive = true;

    const fetchAuction = async () => {
      if (!id) {
        if (isActive) setData([]);
        return;
      }

      try {
        const results = await actionByID(decodeId(id));

        if (isActive) {
          setData(Array.isArray(results) ? results : []);
        }
      } catch (error) {
        console.error("Failed to load auction:", error);

        if (isActive) {
          setData([]);
        }
      }
    };

    fetchAuction();

    return () => {
      isActive = false;
    };
  }, [id]);

  return (
    <>
      <LotSEO data={data} />
      <Banner data={data} />
      <Lot data={data} />
    </>
  );
};

export default React.memo(View);
